import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";

export const getActiveOrders = (stationId, limit) => {
  const data = {
    ProcedureName: "GetOrderRealTimeDsp",
    Parameters: {
      _stationId: stationId,
      limi: limit,
      _collect: 0,
    },
  };

  return axios.post(
    `${aspNetUrl}ReportListView/getreportdatatablefromhamazon`,
    data,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const updateStatus = (orderId, newStatus) => {
  const data = {
    orderId: orderId,
    status: newStatus,
  };
  return axios.post(`${aspNetUrl}Order/UpdateOrderStatus`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

/**
 * Reorder an order in the queue.
 * Only `betweenById` is supported for now (needs two neighbor ids).
 * Edge moves (first/last slot) will use `beforeById` / `afterById` once the API adds them.
 *
 * @param {string|number} orderId
 * @param {{ kind: "betweenById"; before: string; after: string }} rankBody
 */
export const updateOrder = (orderId, rankBody) => {
  return axios.put(`${newApiBaseUrl}/orders/${orderId}/rank`, rankBody, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

// export const updateOrder = async (orderId, newStatus) => {
//   const res = await axios.get(`${aspNetUrl}ListView/GetAllTableProp`, {
//     headers: {
//       Authorization: `bearer ${localStorage.token}`,
//       "Access-Control-Allow-Origin": "*",
//     },
//   });
//   console.log(res);
// };
